import { render, staticRenderFns } from "./AddProfilePopup.vue?vue&type=template&id=4982af40&scoped=true"
import script from "./AddProfilePopup.vue?vue&type=script&lang=js"
export * from "./AddProfilePopup.vue?vue&type=script&lang=js"
import style0 from "./AddProfilePopup.vue?vue&type=style&index=0&id=4982af40&prod&lang=scss&scoped=true"
import style1 from "./AddProfilePopup.vue?vue&type=style&index=1&id=4982af40&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4982af40",
  null
  
)

export default component.exports